<div class="container">
    <h5>
        <span *ngIf="editPage; else addPageHeader">Modifica Prodotto</span>
        <ng-template #addPageHeader><span>Aggiungi Prodotto</span></ng-template>
    </h5>
    <div class="row">
        <div class="col-sm-4"> <!--RIGHT COLUMN-->
            <div class="welldone-card mb-3">
                <div class="welldone-card-body">
                    <h5 class="mb-3">Immagine cover</h5>
                    <div class="edit-profile-pic shadow">
                        <img [src]="product.coverImage && product.coverImage !== '' ? product.coverImage : 'assets/tshirt.png' " alt="product cover image"/>
                        <label class="edit-icon pencil shadow">
                            <img src="assets/icons/pencil-fill.svg" alt="edit"/>
                            <input type="file" accept=".png, .jpg, .jpeg" id="edit-pencil"
                                   (change)="uploadProductImage($event)"/>
                        </label>
                        <div class="edit-icon cross shadow" (click)="removeCoverImage()">
                            <img src="assets/icons/x-lg.svg" alt="delete"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="welldone-card mb-3">
                <div class="welldone-card-body">
                    <h5 class="mb-3">Stato</h5>
                    <select class="form-control form-control-solid" id="isVisible" [(ngModel)]="product.isVisible" name="isVisible">
                        <option [value]="1">Visibile</option>
                        <option [value]="0">Nascosto</option>
                    </select>
                </div>
            </div>

            <div class="welldone-card">
                <div class="welldone-card-body">
                    <h5 class="mb-3">Categorie</h5>
                    <welldone-multiselect
                                             [placeholder]="'Seleziona le categorie disponibili'"
                                             [settings]="usersDropdownSettings"
                                             [data]="categoriesList"
                                             [(ngModel)]="selectedCategories"
                                             [ngModelOptions]="{standalone: true}"
                    >
                    </welldone-multiselect>
                </div>
            </div>

        </div>
        <div class="col-sm-8"> <!--LEFT COLUMN-->
            <div class="welldone-card">
                <div class="welldone-card-body">
                    <form #addProductForm="ngForm" class="w-100">
                        <div class="container-fluid">
                            <div class="row">
                                <div class=" col-sm-6">
                                    <label for="addProductName" class="form-label required">Nome prodotto</label>
                                    <input type="text" class="form-control form-control-solid" id="addProductName"
                                           [(ngModel)]="product.name" name="productName"
                                    >
                                </div>
                                <div class=" col-sm-6">
                                    <label for="productShortDescription" class="form-label required">Breve descrizione</label>
                                    <input class="form-control form-control-solid" type="text"
                                           [(ngModel)]="product.shortDescription"
                                           name="productShortDescription"
                                           id="productShortDescription"
                                           maxlength="30">
                                    <p>Massimo 30 caratteri</p>
                                </div>
                                <div class="col-sm-12">
                                    <label for="addProductName" class="form-label required">Descrizione</label>
                                    <jodit-editor [config]="wysiwygConfig" id="message-text" name="message-text"
                                                  [(ngModel)]="product.description" required ></jodit-editor>
                                    <p>Verrà visualizzata quando un prodotto viene ispezionato</p>
                                </div>
                                <div class="col-6">
                                    <label for="addproductreducedPrice" class="form-label required">Prezzo</label>
                                    <input type="text" class="form-control form-control-solid" id="addproductreducedPrice"
                                           [(ngModel)]="product.fullPrice" name="addproductreducedPrice"
                                    >
                                </div>
                                <div class="col-6">
                                    <label for="addproductFullPrice" class="form-label required">Prezzo Scontato</label>
                                    <input type="text" class="form-control form-control-solid" id="addproductFullPrice"
                                           [(ngModel)]="product.reducedPrice" name="addproductFullPrice"
                                    >
                                    <p>Se impostato uguale al prezzo intero, verrà visualizzato solo il prezzo interno.
                                        Se differente, verrà visualizzato quello scontato </p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="welldone-card mb-3 mt-3">
                <div class="welldone-card-body">
                <h5 class="mb-3">Media</h5>

                    <input type="file" class="form-control form-control-solid mb-3" id="addProductImage"
                           aria-describedby="tutor-document-front" aria-label="Upload"
                           [(ngModel)]="product.images"
                           name="addProductImage"
                           accept="image/png, image/gif, image/jpeg"
                           multiple
                           (change)="chooseImage($event)"
                    />
                    <lib-image-gallery [listImageUrl]="imagesUrl"
                                       (deleteEvent)="onImageDeleted($event)">
                    </lib-image-gallery>
                </div>
            </div>

            <div class="welldone-card-footer">
                <button class="btn btn-secondary me-2" (click)="goBack()">
                    Annulla
                </button>

                <button class="btn btn-primary"  *ngIf="editPage; else addPageBtn"
                        [disabled]="!productValidation(product)"
                        (click)="editProduct(product)"> Salva
                </button>
                <ng-template #addPageBtn>
                    <button class="btn btn-primary"
                            [disabled]="!productValidation(product)"
                            (click)="addProduct(product)"> Crea
                    </button>
                </ng-template>
            </div>


            <app-shop-barcode [productId]="productId" *ngIf="editPage">
            </app-shop-barcode>
        </div>
    </div>
</div>
